module.exports = __webpack_public_path__ + "img/expired-icon.590f4560.png";